import script from './panel-date-pick.vue_vue_type_script_lang.mjs';
export { default } from './panel-date-pick.vue_vue_type_script_lang.mjs';
import { render } from './panel-date-pick.vue_vue_type_template_id_78e07aa7_lang.mjs';

script.render = render;
script.__file = "packages/components/date-picker/src/date-picker-com/panel-date-pick.vue";
//# sourceMappingURL=panel-date-pick.mjs.map
